// extracted by mini-css-extract-plugin
export default {"sm-separator":"sm-separator--2-eWr","smSeparator":"sm-separator--2-eWr","md-separator":"md-separator--1dABa","mdSeparator":"md-separator--1dABa"};